import React from 'react';

export default function FlagImg({ code, size = 24, style = {} }) {
  if (!code || code.length !== 2) return null;
  const src = `https://flagcdn.com/w40/${code.toLowerCase()}.png`;
  return (
    <img
      src={src}
      height={size}
      alt={code.toUpperCase()}
      style={{
        display: 'inline-block',
        verticalAlign: 'middle',
        borderRadius: 2,
        flexShrink: 0,
        ...style,
      }}
      loading="lazy"
    />
  );
}
